<template>
    <div class="layout-book">

        <div class="uk-section uk-section-default uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding-large hero" v-bind:style="{ backgroundImage: `url(${page.heroImage.large4x3})`}" v-if="!!page.heroImage && page.heroImage.id > 0">
            <div class="uk-grid uk-margin-xlarge-top" uk-grid>
                <div class="uk-light uk-width-1-2@l uk-width-3-5@m uk-width-1-1@xs uk-margin-xlarge-bottom">

                    <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                    <h1 class="uk-margin-small-top">{{page.title}}</h1>

                    <slot name="summary">
                        <p class="uk-text-lead" v-if="page.subtitle">{{page.subtitle}}</p>
                    </slot>

              </div>
            </div>
        </div>

        <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header" v-else>
          <div class="uk-light uk-container uk-container-small uk-text-center">

              <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
              <h1 class="uk-margin-small-top">{{page.title}}</h1>

              <slot name="summary">
                  <p class="uk-text-lead" v-if="page.subtitle">{{page.subtitle}}</p>
              </slot>

              <slot name="subheader"></slot>
          </div>
        </div>

        <!-- <FloatingBadge :text="page.summary" badgeClass="background-green"/> -->

        <div class="uk-section uk-section-small uk-background-darkest uk-text-center uk-light">
            <div class="uk-container uk-container-small">
                <h3 class="uk-margin-remove"><em class="text-green">{{page.summary}}</em></h3>
            </div>
        </div>

        <div class="uk-section uk-section-medium uk-background-white" v-if="page.content">
            <div class="uk-container uk-container-small">
                <div class="uk-flex" uk-grid>
                    <div class="uk-width-1-2">
                        <div class="content" v-html="page.content"></div>
                        <!-- <div class="square uk-background-cover" v-bind:style="{ backgroundImage: `url(${readOneBook.authorImage.largeSquare})`}"></div> -->

                    </div>
                    <div class="uk-width-1-2 uk-light">
                        <img :src="page.image.medium" />
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-section uk-background-darker" v-if="readOneBook.AuthorBio || readOneBook.IllustratorBio">
            <div class="uk-container  uk-light">
                <div class="uk-flex uk-flex-center" uk-grid>
                    <div class="uk-width-1-2@m" v-if="readOneBook.AuthorBio">
                        <div class="uk-flex" uk-grid>
                            <div class="uk-width-2-5@s" v-if="!!readOneBook.AuthorImage && readOneBook.authorImageid > 0">
                                <div class="square uk-background-cover" v-bind:style="{ backgroundImage: `url(${readOneBook.authorImage.largeSquare})`}"></div>
                            </div>
                            <div class="uk-width-3-5@s" v-if="readOneBook.AuthorBio">
                                <h4>About the <b>Author</b></h4>
                                <div class="content" v-html="readOneBook.AuthorBio"></div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-2@m" v-if="readOneBook.IllustratorBio">
                        <div class="uk-flex" uk-grid>
                            <div class="uk-width-2-5@s" v-if="!!readOneBook.AuthorImage && readOneBook.authorImage.id > 0">
                                <div class="square uk-background-cover" v-bind:style="{ backgroundImage: `url(${readOneBook.IllustratorImage.largeSquare})`}"></div>
                            </div>
                            <div class="uk-width-3-5@s" v-if="readOneBook.IllustratorBio">
                                <h4>About the <b>Illustrator</b></h4>
                                <div class="content" v-html="readOneBook.IllustratorBio"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" />

        <div class="uk-section uk-section background-blue uk-text-center uk-light" v-if="readOneBook && bookConfig && bookConfig.shipping && bookConfig.shipping.length>0">

            <div class="uk-container uk-container-small">

                <div class="text content" v-html="readOneBook.orderText" v-if="readOneBook.orderText" />

                <form name="_xclick" class="uk-form-width-large wp_accept_pp_button_form uk-margin-auto" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">

                    <template v-if="!readOneBook.disableShipping">

                        <h4>Price: <b>${{parseFloat(bookConfig.price).toFixed(2)}}</b></h4>

                        <template v-if="bookConfig.shipping.length>1">
                            <h5>Select shipping</h5>
                            <div class="uk-margin uk-grid-small uk-child-width-1-3 uk-grid">
                                <label v-for="(shipping, index) in bookConfig.shipping"><input :id="shipping.group" v-model="shippingCountry" class="uk-radio" type="radio" :value="shipping.group"> {{shipping.group}}</label>
                            </div>
                        </template>
                        <template v-else >
                            <h5>Shipping: <b>{{bookConfig.shipping[0].group}}</b> only</h5>
                        </template>

                    </template>

                    <div class="wp_pp_button_selection_section uk-margin-bottom">
                        <div uk-form-custom="target: > * > span:first-child">
                            <select class="uk-select" v-model="itemChoice">
                                <option value="book">Price {{ readOneBook.disableShipping ? '' : ' + Shipping' }} - ${{itemValue.toFixed(2)}}</option>
                                <option value="bookDonation" v-if="bookConfig.suggestedDonation > 0">Price {{ readOneBook.disableShipping ? '' : ' + Shipping' }} + Suggested Donation - ${{ (itemValue + parseFloat(bookConfig.suggestedDonation)).toFixed(2) }}</option>
                            </select>
                            <button class="uk-button uk-button-default" type="button" tabindex="-1">
                                <span></span>
                                <span uk-icon="icon: chevron-down"></span>
                            </button>
                        </div>
                    </div>

                    <!-- <div class="wp_pp_button_reference_section">
                        <label for="wp_pp_button_reference" class="text-green">Your Email Address</label>
                        <br>
                        <input type="hidden" name="on0" value="Reference">
                        <div class="uk-margin-bottom">
                            <div class="uk-inline uk-width-1-1">
                                <a class="uk-form-icon" href="#" uk-icon="icon: mail"></a>
                                <input type="email" name="os0" v-model="email" class="uk-input uk-margin wp_pp_button_reference">
                            </div>
                        </div>
                    </div> -->

                    <h3 class="uk-margin-remove">Your total: <b>${{amount.toFixed(2)}}</b></h3>

                    <input type="hidden" name="cmd" value="_donations">
                    <input type="hidden" name="bn" value="LowellMilkenCenter_BookDonation">
                    <input type="hidden" name="business" value="lmcconard@gmail.com">
                    <input type="hidden" name="currency_code" value="USD">
                    <input type="hidden" name="item_name" :value="itemName">
                    <input type="hidden" name="amount" :value="amount">
                    <input type="hidden" name="return" value="https://www.lowellmilkencenter.org/your-book-is-on-the-way/">
                    <input type="hidden" name="rm" value="0">
                    <!-- <input type="hidden" name="email" :value="email"> -->

                    <div class="wp_pp_button_submit_btn uk-margin">
                        <input type="submit" name="submit" class="uk-button theme-button button-green uk-width-1" :value="shippingCountry ? (readOneBook.buttonLabel || `Donate via PayPal for your item!`) : `Please select your shipping country.`" :disabled="!shippingCountry">
                    </div>

                </form>

            </div>
        </div>

    </div>
</template>

<script>
import gql from 'graphql-tag'
import _ from 'lodash'

// GraphQL query
const readBookQuery = gql`
    query($id: ID!) {
      readOneBook(filter: { id: { eq: $id }}){
        authorBio
        authorImage {
            id
            small
            largeSquare
        }
        illustratorBio
        illustratorImage {
            id
            small
            largeSquare
        }
        orderText
        bookConfig
        disableShipping
        buttonLabel
      }
    }
`

export default {
    data() {
        return {
            readOneBook: {},
            shippingCountry: '',
            itemChoice: "bookDonation",
            bookConfig: {}
        }
    },
    inject: [ 'state', 'theme' ],
    props: ['page', 'parent'],
    watch: {
        'readOneBook.bookConfig' (newConfig, oldConfig) {
            this.bookConfig = JSON.parse(newConfig)
            this.shippingCountry = this.bookConfig?.shipping[0].group
            if(this.bookConfig?.suggestedDonation == 0)
                this.itemChoice = "book"
        }
    },
    apollo: {
        readOneBook: {
            query: readBookQuery,
            variables() {
                return {
                    id: this.page.id
                }
            },
            loadingKey: 'loading'
        }
    },
    computed: {
        itemName() {
            var pick = "Book"
            if(this.itemChoice == "bookDonation") {
                pick = "Book + Donation"
            }
            return `${this.bookConfig.bookTitle} - ${pick} (${this.shippingCountry})`
        },
        itemValue() {
            if(this.bookConfig && this.bookConfig.price) {

                let value = parseFloat(this.bookConfig.price)
                if(!!this.shippingCountry && !this.readOneBook.disableShipping) {
                    let country = this.shippingCountry
                    let shipping = _.find(this.bookConfig.shipping, function(e) { return e.group == country })

                    if(shipping) {
                        value += parseFloat(shipping.price)
                    }
                }
                return value
            }
        },
        amount() {
            var amount = this.itemValue;
            if(this.itemChoice == "bookDonation" && this.bookConfig.suggestedDonation) {
                amount += parseFloat(this.bookConfig.suggestedDonation);
            }
            return amount
        }
    }

}
</script>
